import WelcomeGif from '@assets/welcome.gif';
import BtnLanguage from '@atoms/BtnLanguage';
import LocalImage from '@atoms/LocalImage';
import { Box, Text } from '@components/primitives';
import config from '@config';
import colors from '@theme/colors';
import { SVG_ICONS } from '@utils/SvgIcons';
import React, { useEffect, useState } from 'react';
import { View, InteractionManager } from 'react-native';
import styles from './style';

interface Props {
  item: {
    cardColor: string;
    textContext: string;
  };
  isKeyboardOpen: boolean;
}

function shouldShowLanguageSelector() {
  if (config.ENVIRONMENT !== 'production') {
    return (
      <Box marginTop={10} top={5} right={5} position="absolute">
        <BtnLanguage />
      </Box>
    );
  }
  return null;
}

function shouldShowWelcomText(show: boolean, textContext: string) {
  if (show)
    return (
      <Text
        testID="txtWelcome"
        marginX={26}
        paddingBottom={26}
        variant="md-bold"
        color={colors.neutral.cotton}
        style={styles.textStyle}>
        {textContext}
      </Text>
    );
  return null;
}

export function shouldRenderWelcomeAsset(showGif: boolean) {
  return showGif && <LocalImage source={WelcomeGif} resizeMode="center" style={styles.artwork} />;
}

const WelcomCards: React.FC<Props> = ({
  item = {
    cardColor: '',
    textContext: '',
  },
  isKeyboardOpen = false,
}) => {
  const [showGif, setShowGif] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;
    let timeoutId: ReturnType<typeof setTimeout>;

    // Reset GIF state when component mounts (important for logout scenarios)
    setShowGif(false);

    // Primary method: Use InteractionManager for smooth loading
    const interaction = InteractionManager.runAfterInteractions(() => {
      if (isMounted) {
        setShowGif(true);
      }
    });

    // Fallback method: Use timeout to ensure GIF shows even if InteractionManager fails
    timeoutId = setTimeout(() => {
      if (isMounted) {
        setShowGif(true);
      }
    }, 1000); // 1 second fallback

    return () => {
      isMounted = false;
      interaction.cancel?.();
      clearTimeout(timeoutId);
    };
  }, []); // Empty dependency array to run only on mount

  return (
    <View style={[styles.cardContainer, { backgroundColor: item.cardColor }]}>
      <View style={styles.logoStyle}>{SVG_ICONS.welcome.whiteGGLogo}</View>
      <View>{shouldRenderWelcomeAsset(showGif)}</View>
      {shouldShowWelcomText(!isKeyboardOpen, item.textContext)}
      {shouldShowLanguageSelector()}
    </View>
  );
};

export default WelcomCards;
